import Rotator from './Rotator';
import {$window, $body} from '../../../../../ig_template/Resources/Public/JavaScript/Constants';

export default class Rotation {
    constructor($rotation) {
        this.$rotation = $rotation;
        this.bindHandlers();
    }

    bindHandlers() {
        let _self = this;

        if($window.width() < 850) {
           this.$rotation.find('.ig-rotator-rotation-title-responsive').on('click', function() {
               if(_self.$rotation.data('expanded') == 1) {
                   _self.contractContent();
               }else {
                   _self.expandContent();
               }
           });
        }else {
            this.$rotation.find('.ig-rotator-rotation-title-responsive').off('click');
        }
    }

    getRowHeight(padding = false) {
        let height = this.$rotation.find('> .row').outerHeight();

        if(padding === true) {
            height += 2 * this.padding[0];
        }

        return height;
    }

    getRotationHeight() {
        return this.$rotation.outerHeight();
    }

    set height(height) {
        this.$rotation.css('height', height);
    }

    get padding() {
        let top = this.$rotation.css('paddingTop'),
            right = this.$rotation.css('paddingRight'),
            bottom = this.$rotation.css('paddingBottom'),
            left = this.$rotation.css('paddingLeft');

        let padding = [top, right, bottom, left];

        for(let i = 0; i < padding.length; i++) {
            padding[i] = parseInt(padding[i]);
        }

        return padding;
    }

    setFront() {
        this.$rotation.addClass('front');
    }

    removeFront() {
        this.$rotation.removeClass('front');
    }

    rotateBackwards() {
        this.removeFront();
        this.$rotation.addClass('rotateBackwards');
    }

    rotateForwards() {
        this.setFront();
        this.$rotation.addClass('rotateForwards');
    }

    resetRotation() {
        this.$rotation.removeClass('rotateBackwards');
        this.$rotation.removeClass('rotateForwards');
    }

    setExpandHeight(height) {
        this.$rotation.data('expand-height', height);
    }

    getResponsiveTitleHeight() {
        return this.$rotation.find('.ig-rotator-rotation-title-responsive').outerHeight();
    }

    expandContent() {
        this.$rotation.data('expanded', 1);
        this.$rotation.find('> .row').css('display', 'block');
        $('.tx-ig-rotator').css('height', this.$rotation.data('expand-height'));
    }

    contractContent() {
        this.$rotation.data('expanded', 0);
        this.$rotation.find('> .row').css('display', 'none');
        $('.tx-ig-rotator').css('height', this.getResponsiveTitleHeight() + 2 * this.padding[0]);
    }
}